import React from 'react';
import { Flex, Portal, Spinner, SpinnerProps, Text } from '@chakra-ui/react';

interface LoaderProps {
  /**
   * Size of the spinner
   * @default 'xl'
   */
  size?: SpinnerProps['size'];
  /**
   * Optional loading message to display below the spinner
   */
  message?: string;
  /**
   * Z-index for the loader overlay
   * @default 10000
   */
  zIndex?: number;
  /**
   * Background color with opacity for the overlay
   * @default 'rgba(255, 255, 255, 0.2)'
   */
  background?: string;
}

export function Loader({
  size = 'xl',
  message,
  zIndex = 10000,
  background = 'rgba(255, 255, 255, 0.2)',
}: LoaderProps = {}): JSX.Element {
  return (
    <Portal>
      <Flex
        position="fixed"
        top={0}
        bottom={0}
        left={0}
        right={0}
        zIndex={zIndex}
        justifyContent="center"
        alignItems="center"
        backdropFilter="blur(4px)"
        background={background}
        data-testid="loading"
        role="progressbar"
        aria-label={message ?? 'Loading'}
        aria-live="polite"
        flexDirection="column"
        gap={4}
      >
        <Spinner size={size} thickness="3px" speed="0.65s" />
        {message && (
          <Text fontSize="md" fontWeight="medium" color="gray.700">
            {message}
          </Text>
        )}
      </Flex>
    </Portal>
  );
}

export default Loader;
